import React from 'react'
import styled from 'styled-components'
import Button from '../../../../../components/buttons/buttons.component.jsx'
import StyledFlexContainer from './../../../../../components/containers/flex-container.component'
import { MEDIUMGRAY } from '../../../../../styles/colors.style'
import { breakpoints } from '../../../../../constants'
import { CouponInput } from '../../../../../components/form-components/inputs.component.jsx'
import { CouponService } from './../../../../../services/coupon.service'

const StyledValueContainer = styled.div`
	text-align: center;

	.label {
		font-size: 15px;
		margin-bottom: 7px;
	}

	.value {
		color: ${MEDIUMGRAY};
		font-size: 3.6rem;
		margin-bottom: 1.3rem;

		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			margin-bottom: initial;
		}
	}
`

const DiscountCoupon = ({ onApply, value, discountPercentage, ...props }) => {
	const totalValue = CouponService.applyDiscount(value, discountPercentage)
	return (
		<StyledFlexContainer marginTop={0}>
			<CouponInput
				id="couponCode"
				label="Insira o código do cupom"
				className={'col-4'}
				maxLength={16}
				style={{ textTransform: 'uppercase' }}
				normalize
				{...props}
			/>
			<Button
				primary
				onClick={onApply}
				type={'button'}
				className={'col-3 apply-coupon'}
				id="btn-coupon-apply">
				Aplicar
			</Button>
			<div className={'col-1 filler'} />
			<StyledValueContainer className={'col-4 total-info-coupon'}>
				<div className={'label'}>Valor a pagar</div>
				<div className={'value'}>{Number(totalValue).$toReais()}</div>
			</StyledValueContainer>
		</StyledFlexContainer>
	)
}

export default DiscountCoupon
